import { render, staticRenderFns } from "./VStepLink.vue?vue&type=template&id=06fc683a&"
import script from "./VStepLink.vue?vue&type=script&lang=js&"
export * from "./VStepLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports